import { apiClient } from "../../utils/apiClient";
import { Vehiculo } from "../../types/vehiculo";
import { kilometrajeResponse } from "../../types/kilometrajeResponse";

//trae el código del vehículo desde el ERP Oracle
export const getVehiculoOracleByPlaca = (placa: string): Promise<Vehiculo[]> => {
    return apiClient.get(`/vehicles/erp/placa/${placa}`).then((response)=> response.data);
}

export const getVehiculoByPlaca = (placa: string): Promise<Vehiculo[]> => {
    return apiClient.get(`/vehicles/placa/${placa}`).then((response) => response.data);
}

export const upsertVehiculo = (vehiculo: Vehiculo) : Promise<Vehiculo> => {
    return apiClient.post("/vehicles", vehiculo).then((response) => response.data);
}

export const getKilometrajeAnterior = (placa: string): Promise<kilometrajeResponse> => {
    return apiClient.get(`/vehicles/getKilometrajeAnterior/${placa}`).then((response) => response.data);
}

export const getUltimosKilometrosYHoras = (placa: string): Promise<kilometrajeResponse> => {
    return apiClient.get(`/vehicles/getUltimosKilometrosYHoras/${placa}`).then((response) => response.data);
}

export const fetchAllVehicles = (): Promise<Vehiculo[]> => {
    return apiClient.get(`/vehicles`).then((response) => response.data);
}

export const fetchAllVehiclesOracle = (): Promise<Vehiculo[]> => {
    return apiClient.get(`/vehicles/erp`).then((response) => response.data);
}